var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { style: { display: "block" }, attrs: { xs: "12", md: "12" } },
        _vm._l(_vm.images, function (img, i) {
          return _c("div", { key: img.key, staticClass: "img" }, [
            _c(
              "div",
              { staticClass: "remove action-bar" },
              [
                img.productImage?.setAsCover
                  ? _c("w-button", {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("cover-image"),
                          expression: "$ct('cover-image')",
                        },
                      ],
                      staticClass: "cover",
                      attrs: { icon: "star", flat: "" },
                    })
                  : _vm._e(),
                _c("w-spacer"),
                _c(
                  "w-dropdown",
                  {
                    attrs: { flat: "", items: _vm.getDropDownItems(img) },
                    on: {
                      click: function ($event) {
                        return $event(img, i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "bars" } })],
                  1
                ),
              ],
              1
            ),
            _c("div", {
              staticClass: "img-wrap",
              style: { backgroundImage: "url(" + img.url + ")" },
            }),
          ])
        }),
        0
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: _vm.product.Images.length > 0 ? 12 : 12 } },
        [
          _c("app-file-upload", {
            attrs: {
              "allowed-extensions": ["gif", "png", "jpg", "jpeg", "webp"],
              label: _vm.$ct("drop-your-images"),
            },
            on: {
              input: function ($event) {
                return _vm.onFile($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }